// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodSensorySessionId } from './FoodSensorySession';
import { foodProjectId } from './FoodProject';
import { foodSensoryTestType } from './FoodSensoryTestType';
import { foodSensoryRoundStatus } from './FoodSensoryRoundStatus';
import { z } from 'zod';
export const foodSensoryRoundId = (z.number());
export const foodSensoryRound = z.object({
    id: foodSensoryRoundId,
    sensory_session_id: foodSensorySessionId,
    project_id: foodProjectId,
    test_type: foodSensoryTestType,
    blinded: z.boolean(),
    title: z.string().nullable(),
    display_order: z.number(),
    status: foodSensoryRoundStatus,
    is_current: z.boolean(),
    opened_at: z.date().nullable(),
    revealed_at: z.date().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    portion_g: z.string().nullable(),
    reveal_blocks: z.unknown().nullable(),
    presenter_notes_tasting: z.string().nullable(),
    presenter_notes_reveal: z.string().nullable(),
});
export const foodSensoryRoundInitializer = z.object({
    id: foodSensoryRoundId.optional(),
    sensory_session_id: foodSensorySessionId,
    project_id: foodProjectId,
    test_type: foodSensoryTestType.optional(),
    blinded: z.boolean().optional(),
    title: z.string().optional().nullable(),
    display_order: z.number().optional(),
    status: foodSensoryRoundStatus.optional(),
    is_current: z.boolean().optional(),
    opened_at: z.date().optional().nullable(),
    revealed_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    portion_g: z.string().optional().nullable(),
    reveal_blocks: z.unknown().optional().nullable(),
    presenter_notes_tasting: z.string().optional().nullable(),
    presenter_notes_reveal: z.string().optional().nullable(),
});
export const foodSensoryRoundMutator = z.object({
    id: foodSensoryRoundId.optional(),
    sensory_session_id: foodSensorySessionId.optional(),
    project_id: foodProjectId.optional(),
    test_type: foodSensoryTestType.optional(),
    blinded: z.boolean().optional(),
    title: z.string().optional().nullable(),
    display_order: z.number().optional(),
    status: foodSensoryRoundStatus.optional(),
    is_current: z.boolean().optional(),
    opened_at: z.date().optional().nullable(),
    revealed_at: z.date().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    portion_g: z.string().optional().nullable(),
    reveal_blocks: z.unknown().optional().nullable(),
    presenter_notes_tasting: z.string().optional().nullable(),
    presenter_notes_reveal: z.string().optional().nullable(),
});
//# sourceMappingURL=FoodSensoryRound.js.map